import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { accentCardSx, accentTextSx } from '../common/theme/accents';

// The row of counts a desk reads first.
//
// Each one is a fact and a way to act on it: the number answers "how much", and the tile goes to
// the screen that answers "which ones". A count nobody can open is a poster, not a dashboard.
const DashboardTiles = ({ tiles, unavailable }) => {
  const navigate = useNavigate();
  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(3, 1fr)', lg: `repeat(${tiles.length}, 1fr)` },
      gap: 2,
      mb: 3,
    }}
    >
      {tiles.map(({ title, value, hint, accent, to }) => (
        <Paper
          key={title}
          variant="outlined"
          onClick={to ? () => navigate(to) : undefined}
          sx={[
            { p: 2.5 },
            accentCardSx(accent),
            to ? { cursor: 'pointer', '&:hover': { borderColor: 'text.secondary' } } : {},
          ]}
          role={to ? 'button' : undefined}
          tabIndex={to ? 0 : undefined}
          onKeyDown={to ? (event) => { if (event.key === 'Enter') navigate(to); } : undefined}
          aria-label={to ? `${title}: ${value}. Open the list` : undefined}
        >
          <Typography color="text.secondary" variant="body2">{title}</Typography>
          <Typography variant="h4" sx={[{ mt: 1 }, accentTextSx(accent)]}>{unavailable ? '—' : value}</Typography>
          {hint && <Typography variant="caption" color="text.secondary">{hint}</Typography>}
        </Paper>
      ))}
    </Box>
  );
};

export default DashboardTiles;
